export const CONFIG_CONTENTS_D2C = {
  spinner: false,
  step: 25000,
  prefix: "£",
  precision: 0,
  max: 100000,
  min: 75000,
  default: 75000,
  thousands: ",",
  higherCoverItemsMaxAmount: 30000, //30% of 100000
  standardCoverItemsMaxAmount: 22500, //30% of 75000
};

export const CONFIG_CONTENTS_D2C_MAX = {
  spinner: false,
  step: 100000,
  prefix: "£",
  precision: 0,
  max: 100000,
  min: 100000,
  default: 100000,
  thousands: ",",
  higherCoverItemsMaxAmount: 30000, //30% of 100000
  standardCoverItemsMaxAmount: 30000, //30% of 100000
};

export const CONFIG_CONTENTS_RENTED_ONLY_D2C = {
  spinner: false,
  step: 10000,
  prefix: "£",
  precision: 0,
  max: 50000,
  min: 20000,
  default: 20000,
  thousands: ",",
};

export const CONFIG_LANDLORD_CONTENTS_LEVEL = {
  spinner: false,
  step: 10000,
  prefix: "£",
  precision: 0,
  max: 50000,
  min: 10000,
  default: 10000,
  thousands: ",",
};

export const CONFIG_CONTENTS_RENTED_ONLY_D2C_MAX = {
  spinner: false,
  step: 50000,
  prefix: "£",
  precision: 0,
  max: 50000,
  min: 50000,
  default: 50000,
  thousands: ",",
};
